"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Settings = require("../Settings");

var _security = require("../Shared/store/security");

var _timezones = require("../Shared/store/timezones");

var _CalendarSetting = require("./components/CalendarSetting");

var _MeetingSetting = _interopRequireDefault(require("./components/MeetingSetting/MeetingSetting"));

var _PasswordSetting = _interopRequireDefault(require("./components/PasswordSetting/PasswordSetting"));

var _UnsubscribeSetting = _interopRequireDefault(require("./components/UnsubscribeSetting/UnsubscribeSetting"));

var actions = _interopRequireWildcard(require("./store/personalProfileSettings/personalProfileSettings.actions"));

var selectors = _interopRequireWildcard(require("./store/personalProfileSettings/personalProfileSettings.selector"));

var constants = _interopRequireWildcard(require("./store/personalProfileSettings/personalProfileSettings.contants"));

var PersonalProfileSettings = function PersonalProfileSettings() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var forceSso = (0, _reactRedux.useSelector)(_security.getForceSso);
  var isLoading = (0, _reactRedux.useSelector)(selectors.getIsLoading);
  var errors = (0, _reactRedux.useSelector)(selectors.getErrors);
  var isUnsubscribed = (0, _reactRedux.useSelector)(selectors.getIsUnsubscribed);
  var days = (0, _reactRedux.useSelector)(selectors.getCalendarPeriods);
  var meetingDuration = (0, _reactRedux.useSelector)(selectors.getMeetingDuration);
  var meetingPlace = (0, _reactRedux.useSelector)(selectors.getMeetingPlace);
  var calendarTimezone = (0, _reactRedux.useSelector)(selectors.getCalendarTimezone);
  var isHideBustCalendarPeriods = (0, _reactRedux.useSelector)(selectors.getIsHideBusyPeriods);
  var isAutoSendInvite = (0, _reactRedux.useSelector)(selectors.getIsAutoSendMeetingInvite);
  var meetingFrequency = (0, _reactRedux.useSelector)(selectors.getMeetingFrequency);
  var meetingLimits = (0, _reactRedux.useSelector)(selectors.getMeetingLimits);
  var timezones = (0, _reactRedux.useSelector)(_timezones.Timezones.selectors.getTimezones);
  (0, _react.useEffect)(function () {
    dispatch(actions.getSettings());
  }, [dispatch]);
  var handleResetPassword = (0, _react.useCallback)(function () {
    return dispatch(actions.resetPassword());
  }, [dispatch]);
  var handleChangePassword = (0, _react.useCallback)(function (_ref) {
    var currentPassword = _ref.currentPassword,
        newPassword = _ref.newPassword,
        newPasswordConfirmation = _ref.newPasswordConfirmation;
    return dispatch(actions.setPassword({
      currentPassword,
      newPassword,
      newPasswordConfirmation
    }));
  }, [dispatch]);
  var handleSaveCalendar = (0, _react.useCallback)(function (newDays) {
    return dispatch(actions.setCalendarPeriod(newDays));
  }, [dispatch]);
  var handleSaveMeetingPreferences = (0, _react.useCallback)(function (preferences) {
    return dispatch(actions.setMeetingsPreferences(preferences));
  }, [dispatch]);
  var handleUnsubscribe = (0, _react.useCallback)(function () {
    return dispatch(actions.unsubscribe());
  }, [dispatch]);
  var durationValue = (0, _react.useMemo)(function () {
    return constants.MEETING_DURATION_OPTIONS.find(function (_ref2) {
      var id = _ref2.id;
      return id === meetingDuration;
    });
  }, [meetingDuration]);
  var durationValueString = durationValue ? "".concat(durationValue.name, ", ") : '';
  var placeValue = (0, _react.useMemo)(function () {
    return constants.MEETING_PLACE_OPTIONS.find(function (_ref3) {
      var id = _ref3.id;
      return id === meetingPlace.place;
    });
  }, [meetingPlace]);
  var placeValueString = placeValue ? "".concat(placeValue.name, ", ") : '';
  var timezoneValue = (0, _react.useMemo)(function () {
    return timezones.find(function (_ref4) {
      var name = _ref4.name;
      return calendarTimezone === name;
    });
  }, [calendarTimezone, timezones]);
  var timezoneValueString = timezoneValue ? "".concat(timezoneValue.title, " Time Zone, ") : '';
  var hideBusyValueString = isHideBustCalendarPeriods ? 'Recipients can not book over existing meetings' : 'Recipients can book over existing meetings';
  var meetingPreferencesValue = "".concat(durationValueString).concat(placeValueString).concat(timezoneValueString).concat(hideBusyValueString);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !forceSso && /*#__PURE__*/_react.default.createElement(_Settings.SettingsItem, {
    title: "Password",
    description: "",
    isLoading: isLoading,
    value: null
  }, /*#__PURE__*/_react.default.createElement(_PasswordSetting.default, {
    onReset: handleResetPassword,
    onSave: handleChangePassword,
    isLoading: isLoading,
    errors: errors
  })), /*#__PURE__*/_react.default.createElement(_Settings.SettingsItem, {
    title: "Calendar availability",
    description: "When sending gifts through Alyce, you can set your availability so recipients can choose the times that\u2019s best for them to connect. Your calendar is",
    isLoading: isLoading,
    value: /*#__PURE__*/_react.default.createElement(_CalendarSetting.CalendarSettingValues, {
      days: days
    })
  }, /*#__PURE__*/_react.default.createElement(_CalendarSetting.CalendarSetting, {
    days: days,
    onSaveCalendar: handleSaveCalendar,
    isLoading: isLoading,
    errors: errors
  })), /*#__PURE__*/_react.default.createElement(_Settings.SettingsItem, {
    title: "Calendar preferences",
    description: "When setting up your calendar through Alyce, you can set your default meeting length, location, timezone, and the ability to respect your calendar. Your defaults are currently",
    isLoading: isLoading,
    value: meetingPreferencesValue
  }, /*#__PURE__*/_react.default.createElement(_MeetingSetting.default, {
    calendarTimezone: calendarTimezone,
    meetingFrequency: meetingFrequency,
    meetingDuration: meetingDuration,
    meetingLimits: meetingLimits,
    meetingPlace: meetingPlace,
    hideBusyCalendarPeriods: isHideBustCalendarPeriods,
    isAutoSendInvite: isAutoSendInvite,
    isLoading: isLoading,
    errors: errors,
    onSave: handleSaveMeetingPreferences
  })), /*#__PURE__*/_react.default.createElement(_Settings.SettingsItem, {
    title: "Subscription preferences",
    description: "You will be unsubscribed from all Alyce gifts and emails. This will also decline any gift invitations you have received",
    isLoading: isLoading,
    value: isUnsubscribed ? 'Unsubscribed' : 'Subscribed'
  }, isUnsubscribed && /*#__PURE__*/_react.default.createElement(_UnsubscribeSetting.default, {
    value: isUnsubscribed,
    isLoading: isLoading,
    onSave: handleUnsubscribe
  })));
};

PersonalProfileSettings.propTypes = {};

var _default = /*#__PURE__*/(0, _react.memo)(PersonalProfileSettings);

exports.default = _default;